import React, { useState } from 'react';
import { Button, Form, TextArea, Icon, Modal } from 'semantic-ui-react';

export default function EdgeStoreSearchModal(props) {
  const [stores, setStores] = useState('');
  const storeList = stores
    .trim()
    .split(/[\s,]/)
    .filter((s) => s.match(/^\d+$/));
  const params = storeList
    .map((storeNumber) => `store_numbers[]=${storeNumber}`)
    .join('&');
  const onConfirm = () => Turbolinks.visit(`${props.link}?${params}`);

  return (
    <Modal
      closeOnDimmerClick
      open={props.isOpen}
      size='fullscreen'
      style={
        {
          right: '0px',
        } /* We need to set the css property `right` due to a bug in semantic-ui-css 2.4.0 and below */
      }
      onClose={props.onClose}
    >
      <Modal.Header>Batch QR Code</Modal.Header>

      <Modal.Content style={{ paddingTop: '11px' }}>
        <em style={{ lineHeight: '1' }}>
          Search for node(s) that you would like to generate and print QR codes.
        </em>
        <Form style={{ marginTop: '10px', marginBottom: '10px' }}>
          <TextArea
            placeholder='i.e 0000, 0001'
            style={{ minHeight: 600 }}
            onChange={(e) => setStores(e.target.value)}
          />
        </Form>
        <em>Please limit your search to 1,000 stores at a time.</em>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={props.onClose}>
          <Icon name='remove' />
          Close
        </Button>

        <Button
          primary
          className='submit'
          disabled={
            storeList.length > 0 && storeList.length <= 1000 ? false : true
          }
          onClick={onConfirm}
        >
          <Icon name='cog' />
          Generate QR Codes
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
